export const OK = 0;
export const SUCCESS_CODES = [OK, "BFF000000"];
export const NOT_LOGIN_CODES = [101002, "AUTH001999"];
